import { useEffect } from 'react';

import { customSessionStorage } from '@crehana/utils';
import { useRouter } from 'next/router';

const SESSION_STORAGE_PREVIOUS_SEARCH_QUERY = '__CREH__previousSearch';

// Todo: We must add a URLSearchParams interface here
const getParamsAsObject = (params: any) => {
  const _object: Record<string, any> = {};

  const keys = params.keys();

  for (const key of keys) {
    const value = params.get(key);
    if (value) {
      _object[key] = value;
    }
  }

  return _object;
};

/*
  This functions makes use of multiple customSessionStorage that look like they can be
  simplified in a simple call at the end of the function. Do not refactor it at least you map
  all the cases, it looks more complex than it is.
*/
const usePersistQueryParams = () => {
  const router = useRouter();
  const { asPath } = router;

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    if (customSessionStorage) {
      const search = window.location.search;
      const previousSearch = customSessionStorage.getItem(
        SESSION_STORAGE_PREVIOUS_SEARCH_QUERY,
      );

      if (previousSearch) {
        if (search) {
          // Merge query params
          const params = getParamsAsObject(new URLSearchParams(search));
          const newParams = getParamsAsObject(
            new URLSearchParams(previousSearch),
          );
          const mergedParams = Object.assign(params, newParams);

          router.replace(asPath, { query: mergedParams });

          customSessionStorage.setItem(
            SESSION_STORAGE_PREVIOUS_SEARCH_QUERY,
            `?${new URLSearchParams(mergedParams).toString()}`,
          );
        } else {
          // Add it the query params entirely
          router.replace(asPath + previousSearch);

          customSessionStorage.setItem(
            SESSION_STORAGE_PREVIOUS_SEARCH_QUERY,
            previousSearch,
          );
        }
      } else {
        customSessionStorage.setItem(
          SESSION_STORAGE_PREVIOUS_SEARCH_QUERY,
          window.location.search,
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePersistQueryParams;
